export const PolicyTableHeadings = {
    fontFamily:"Work Sans",
    fontWeight: 400,
    fontSize: "1rem",
    color: "#2A1D22",
    lineHeight: 1.7,
    padding: "1.5rem 0.75rem",
    backgroundColor: "#F5E9E1",
    borderBottom: "none",
    textAlign:"center"
  }